import { render, staticRenderFns } from "./BaseProductCard.vue?vue&type=template&id=7e7c7746&"
import script from "./BaseProductCard.vue?vue&type=script&lang=js&"
export * from "./BaseProductCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseProductCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports